export default function ArrowIconLeft() {
    return (
        <>
        <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12.7671 15.0007L20.2144 7.55933C20.7651 7.00855 20.7651 6.11792 20.2144 5.573C19.6636 5.02222 18.773 5.02808 18.2222 5.573L9.78468 14.0046C9.25147 14.5378 9.23975 15.3933 9.74366 15.9441L18.2163 24.4343C18.4917 24.7097 18.855 24.8445 19.2124 24.8445C19.5698 24.8445 19.9331 24.7097 20.2085 24.4343C20.7593 23.8835 20.7593 22.9929 20.2085 22.448L12.7671 15.0007Z" fill="white"/>
        </svg>
        </>
    );
}
